import { useState } from 'react';
import { LockKeyhole } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export default function LoginScreen() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (!ok) setError('Incorrect email or password.');
  };

  return (
    <div className="access-denied-screen">
      <Card className="access-denied-card">
        <CardHeader>
          <span className="access-icon"><LockKeyhole /></span>
          <CardTitle>ARPFlow Internal Dashboard</CardTitle>
          <CardDescription>Access is restricted to authorised team members.</CardDescription>
        </CardHeader>
        <CardContent>
          <form className="login-form" onSubmit={handleSubmit}>
            <label className="form-label" htmlFor="login-email">Email</label>
            <Input id="login-email" className="form-input" type="email" autoComplete="username"
                   value={email} onChange={e => { setEmail(e.target.value); setError(null); }}
                   placeholder="you@nakad.co" autoFocus />

            <label className="form-label" htmlFor="login-password">Password</label>
            <Input id="login-password" className="form-input" type="password" autoComplete="current-password"
                   value={password} onChange={e => { setPassword(e.target.value); setError(null); }}
                   placeholder="Password" />

            <Button type="submit" disabled={!email || !password || submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </Button>
            {error && <p className="error-msg">{error}</p>}
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
